import loadable from '@loadable/component';

export const LazyGreetingCard = loadable(() => import(/* webpackChunkName: "content/greetingCard" */ '.'));
